export const maskMobilePhone = (value: string) => {
  if (/\*/g.test(value)) {
    return value;
  }

  if (value.length === 9) {
    return `${value.slice(0, 5).replaceAll(/[0-9]/g, '*')}${value.slice(-4)}`;
  }

  if (value.length === 11) {
    return `${value.slice(0, 7).replaceAll(/[0-9]/g, '*')}${value.slice(-4)}`;
  }

  if (value.length === 16) {
    return `${value.slice(0, 11).replaceAll(/[0-9]/g, '*')}${value.slice(-5)}`;
  }

  return value.replaceAll(/[0-9]/g, '*');
};
